import React, { ReactElement, FunctionComponent } from "react";
import classNames from "classnames";
import { Alert } from "react-bootstrap";

import "./FeatureGroupBoxedIconTitle.scss";

export interface FeatureGroupBoxedIconTitleProps {
    title: string | ReactElement<any>;
    subtitle?: string | ReactElement<any>;
    className?: string;
    alertBoxVariant: string;
    iconClassName: string;
    action?: ReactElement<any>;
}

export const FeatureGroupBoxedIconTitle: FunctionComponent<FeatureGroupBoxedIconTitleProps> = ({
    title,
    subtitle,
    className,
    alertBoxVariant,
    iconClassName,
    action,
}) => {
    return (
        <div className={classNames("feature_group_title", className)}>
            <Alert variant={alertBoxVariant} className="feature_group_title_box">
                <div className="feature_group_label feature_group_title_box_label">
                    <span>
                        <i className={iconClassName} aria-hidden />
                        {title}
                        {!!subtitle && (
                            <span className="feature_group_title_box_sublabel">{subtitle}</span>
                        )}
                    </span>
                </div>
                {!!action && <div className="feature_group_title_action">{action}</div>}
            </Alert>
        </div>
    );
};
